import axios from 'axios'

const leadsURL = 'https://leads-dev.evollu.com'

export const QuestionnaireService = {

  baseURL: leadsURL,

  init (baseURL) {
    this.baseURL = baseURL
  },
  get (srv, slug) {
    if (srv !== null && srv !== '') this.baseURL = srv
    return new Promise((resolve, reject) => {
      axios.get(`${this.baseURL}/questionnaires/${slug}`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  }
}


export const LeadsService = {

  baseURL: leadsURL,

  init (baseURL) {
    this.baseURL = baseURL
  },
  store (srv, data) {
    if (srv !== null && srv !== '') this.baseURL = srv
    return axios.post(`${this.baseURL}/leadweb`, data)
  }
}

